module.exports = __webpack_public_path__ + "img/cfc-01.acbff27f.png";